var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageEmptyGraph(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h180v180H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.722 59.117h62.23a5 5 0 0 1 4.21 2.301l13.298 20.745a5 5 0 0 1-4.21 7.699H30.723a5 5 0 0 1-5-5V64.117a5 5 0 0 1 5-5z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.518 34.576 23.486-8.548a8 8 0 0 1 10.253 4.781l8.549 23.486a8 8 0 0 1-4.782 10.254l-23.486 8.548a8 8 0 0 1-10.254-4.781L2.736 44.83a8 8 0 0 1 4.782-10.254zM151.427 7l21.645 12.497A8 8 0 0 1 176 30.425L163.503 52.07a8 8 0 0 1-10.928 2.928L130.93 42.501a8 8 0 0 1-2.928-10.928l12.497-21.645A8 8 0 0 1 151.427 7zM92.5 85.889l-4.34 24.614a8 8 0 0 1-9.268 6.489l-24.613-4.34a8 8 0 0 1-6.49-9.268l4.34-24.614a8 8 0 0 1 9.268-6.489l24.614 4.34a8 8 0 0 1 6.49 9.268z",
    fill: "#AAAAAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.722 89.878h59.056a5 5 0 0 0 4.003-2.003l11.372-15.19a10 10 0 0 1 8.006-4.007h51.288c5.523 0 10 4.477 10 10v87.608c0 5.522-4.477 10-10 10H35.722c-5.523 0-10-4.478-10-10V99.878c0-5.522 4.477-10 10-10z",
    fill: "#EBEBEB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageEmptyGraph);
export default __webpack_public_path__ + "static/media/image_empty_graph.a6cc1019a4d144d9436e69e864c0dfb2.svg";
export { ForwardRef as ReactComponent };